export default __webpack_public_path__ + "static/media/VENTO WITH LACE.4fdb9e3e.jpg";